import React from 'react';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import ReactTooltip from 'react-tooltip';
import { getMessageStatus } from './messagesHelper';
import { SAlert } from '@avalara/skylab-sdk/react';

export const StaticApplicationMessage = (props) => {
    let { messageType = '', languages, string, params, tooltip = '', nodismiss } = props;
    const messageStatus = getMessageStatus(messageType);
    const dataTip = tooltip ? LANGUAGES_CONTROLLER.format(languages, tooltip, params) : undefined;

    if (dataTip) {
        return (
            <SAlert status="warning" className="mb10">
                <span data-tip={dataTip} className={messageType}>
                    <span>{LANGUAGES_CONTROLLER.formatUtilFormatter(languages, string, params)}</span>
                    <ReactTooltip className={messageType} />
                </span>
            </SAlert>
        )
    } else {
        return (
            <SAlert status={messageStatus} {...(nodismiss && { noDismiss: true })} className="mb10">
                <span>{LANGUAGES_CONTROLLER.format(languages, string, params)}</span>
            </SAlert>
        );
    }
};

export default StaticApplicationMessage;